import { action } from 'client/core/actions'

export const FLASH = 'FLASH'
export const NEW_FLASH = 'NEW_FLASH'
export const HIDE_FLASH = 'HIDE_FLASH'
export const flashes = {
    add: (flash) => action(NEW_FLASH, { flash }),
    hide: (flash) => action(HIDE_FLASH, { flash })
}
export const flash = (flash) => action(FLASH, flash)


// WEBPACK FOOTER //
// ./src/client/features/flashes/actions.js